import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loadingSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  get loadingProgress(): Observable<number> {
    return this.loadingSubject.asObservable();
  }

  showLoader(): void {
    this.loadingSubject.next(1); // Start loading
  }

  hideLoader(): void {
    this.loadingSubject.next(100); // Complete loading
    setTimeout(() => {
      this.loadingSubject.next(0); // Hide loader after a delay
    }, 500); // Adjust the delay as needed
  }
}
